/**
 * ChatPage - Página principal do chat
 * Layout completo com 3 painéis dinâmicos
 */

import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ChatLayout from '../components/ChatLayout';
import { useConversation } from '../hooks';
import type { SidebarView } from '../types';

export const ChatPage: React.FC = () => {
  const { conversationId } = useParams<{ conversationId?: string }>();
  const navigate = useNavigate();

  const [selectedConversationId, setSelectedConversationId] = useState<string | null>(
    conversationId || null
  );

  // ✅ Buscar conversa quando há conversationId na URL para determinar view correta
  const { data: conversationData } = useConversation(conversationId);

  // ✅ View inicial: determina baseada na conversa ou null para usar localStorage
  const [initialView, setInitialView] = useState<SidebarView | null>(null);

  // ✅ Determinar view baseada na conversa carregada
  useEffect(() => {
    if (conversationId && conversationData) {
      let determinedView: SidebarView;

      // Determinar view baseada nas propriedades da conversa
      if (conversationData.groupId) {
        determinedView = 'groups';
      } else if (conversationData.agentStatus === 'active') {
        // ✅ Conversa é de IA se agentStatus='active'
        determinedView = 'ai';
      } else if (conversationData.status === 'closed') {
        determinedView = 'history';
      } else {
        determinedView = 'chats';
      }

      setInitialView(determinedView);
    } else {
      // Sem conversationId, usar null para deixar useChatPreferences decidir (localStorage)
      setInitialView(null);
    }
  }, [conversationId, conversationData]);

  const handleSelectConversation = (id: string) => {
    setSelectedConversationId(id);
    navigate(`/chat/${id}`, { replace: true });
  };

  const handleClearSelection = () => {
    setSelectedConversationId(null);
    navigate('/chat', { replace: true });
  };

  return (
    <div
      className="h-full w-full overflow-hidden"
      style={{ backgroundColor: 'var(--theme-page-background)' }}
    >
      <ChatLayout
        selectedConversationId={selectedConversationId}
        onSelectConversation={handleSelectConversation}
        onClearSelection={handleClearSelection}
        initialView={initialView}
      />
    </div>
  );
};

export default ChatPage;
